import React from 'react';
import { MentalCapacityAssessmentType } from '../utils';

interface LocationOfMcaProps {
  mentalCapacityAssessment: MentalCapacityAssessmentType;
  setMentalCapacityAssessment: React.Dispatch<
    React.SetStateAction<MentalCapacityAssessmentType>
  >;
}
const LocationOfMca: React.FC<LocationOfMcaProps> = ({
  mentalCapacityAssessment,
  setMentalCapacityAssessment,
}) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h1 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--l" htmlFor="location-of-mca">
          Location of mental capacity assessment form
        </label>
      </h1>
      <div id="location-of-mca-hint" className="govuk-hint">
        The location of the mental capacity assessment information.
      </div>
      <textarea
        className="govuk-textarea"
        id="location-of-mca"
        name="LocationOfMca"
        rows={5}
        aria-describedby="location-of-mca-hint"
        value={mentalCapacityAssessment.locationOfMca}
        onChange={e => {
          setMentalCapacityAssessment(prev => ({
            ...prev,
            locationOfMca: e.target.value,
          }));
        }}
      />
    </div>
  );
};

export default LocationOfMca;
